function journalPage() {
  const dropdown = document.getElementById('journal_search_year');
  const form = document.querySelector("form[name='journal_search']");

  let journalOffset = document.getElementById('journal_search_offset');

  dropdown.addEventListener('change', function (event) {
    let value = event.currentTarget.value;
    if (value) {
      removeParam('journal_search[offset]');
      journalOffset.value = 0;
      form.submit();
    }
  });
}
